export function validatePassword(pwd: string): boolean {
  return (
    pwd.length >= 10 &&
    /[a-zA-Z]/.test(pwd) &&
    /[0-9]/.test(pwd)
  );
}
